import type React from 'react';

export const Gradient: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="100%"
    height="100vh"
    style={{
      position: 'absolute',
      top: 0,
      left: 0,
      pointerEvents: 'none',
      zIndex: 0,
      ...props.style,
    }}
    {...props}
  >
    <defs>
      <linearGradient id="grad1" x1="0%" y1="0%" x2="5%" y2="60%">
        <stop offset="0%" style={{ stopColor: 'rgb(255, 0, 255)', stopOpacity: 0.5 }} />
        <stop offset="100%" style={{ stopColor: 'rgb(255, 255, 255)', stopOpacity: 0 }} />
      </linearGradient>
      <radialGradient id="grad2" x1="0%" y1="0%" x2="15%" y2="70%">
        <stop offset="10%" style={{ stopColor: 'rgb(0, 255, 0)', stopOpacity: 0.9 }} />
        <stop offset="100%" style={{ stopColor: 'rgb(255, 255, 255)', stopOpacity: 0 }} />
      </radialGradient>
    </defs>
    <rect width="100%" height="100%" fill="url(#grad1)" />
    <ellipse cx="110%" cy="0" rx="100%" ry="60%" fill="url(#grad2)" />
    <ellipse cx="-10%" cy="0" rx="90%" ry="70%" fill="url(#grad2)" />
    <ellipse cx="-10%" cy="0" rx="90%" ry="70%" fill="url(#grad2)" />
    <rect width="100%" height="100%" fill="url(#grad1)" />
  </svg>
);

export default Gradient;
